import { createSlice } from "@reduxjs/toolkit";
import updatedReport from "@custom/rtk-apis/report/updateReport";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const updateReportSlice = createSlice({
  name: "updateReportSlice",
  initialState,
  reducers: {revertStatus (state:any) { state.status = ""; }},
  extraReducers: (builder) => {
    console.log("----------", builder)
    builder
      .addCase(updatedReport.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(updatedReport.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(updatedReport.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default updateReportSlice.reducer;
export const { revertStatus } = updateReportSlice.actions;
